import { useEffect, useState } from 'react';
import { getJobById, getTotalAISuggestionViewedCandidates, ICvViewAnalytics } from 'wisestep-api';

import CountWithTextCard from '../countWithTextCard';

const JobCrmAiSuggestionViewedCandidates = ({ payload }: { payload: ICvViewAnalytics }) => {
  const [count, setCount] = useState<number>(0);
  useEffect(() => {
    const fetchData = async () => {
      const jobDetails = await getJobById(payload.jobId ?? '');
      payload.jobCode = jobDetails?.data?.jobCode;
      const response = await getTotalAISuggestionViewedCandidates(payload);
      setCount(response.data?.aggregations?.aggregation?.buckets.length ?? 0);
    };
    fetchData();
  }, [payload]);
  return <CountWithTextCard count={count} text="Total Viewed AI Suggestions" />;
};
export default JobCrmAiSuggestionViewedCandidates;
